import { interactionsActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_INTERACTION,
  FETCH_ATCCLASSIFICATION,
  FETCHING_INTERACTION,
  FETCH_INTERACTION_ERROR,
  FETCH_INTERACTIONS,
  FETCHING_INTERACTIONS,
  FETCH_INTERACTIONS_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_INTERACTION,
  DELETE_INTERACTION,
  ADD_INTERACTION,
  EDIT_INTERACTION,
  FORM_TOUCHED,
  NEW_FORM_INTERACTION,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  INTERACTION_FORM_ERROR,
  RESET_STATE
} = interactionsActions

const initialState = {
  loadingInteraction: false,
  loadingInteractions: false,
  fetchInteractionError: false,
  fetchInteractionsError: false,
  atcClassifications: [],
  interactions: [],
  order: {
    column: 'interacaoTipo_id',
    direction: 1
  },
  interaction: {
    interacaoTipo_id: '',
    mdcmnts: '',
    excetosMed1: '',
    excetosMed2: ''
  },
  interactionsPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  interactionFormErrors: {},
  interactionFormTouched: false,
  modalOpen: false
}

const interactionSchema = {
  add: {
    interacaoTipo_id: {
      required: true
    },
    mdcmnts: {
      minItems: 2,
      maxItems: 2,
      required: true
    },
    excetosMed1: {
      required: false
    },
    excetosMed2: {
      required: false
    }
  },
  edit: {
    interacaoTipo_id: {
      required: true
    },
    mdcmnts: {
      minItems: 2,
      maxItems: 2,
      required: true
    },
    excetosMed1: {
      required: false
    },
    excetosMed2: {
      required: false
    }
  }
}

const InteractionValidate = new ValidateFormObject(interactionSchema)

const interactions = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case FETCH_ATCCLASSIFICATION:
      return {
        ...state,
        atcClassifications: action.atcClassifications
      }
    case CHANGE_INTERACTION:
      formSchemaType = action.interaction._id ? 'edit' : 'add'
      return {
        ...state,
        interaction: action.interaction,
        interactionFormErrors: InteractionValidate.validate({
          formObject: action.interaction,
          formSchemaType
        })
      }
    case INTERACTION_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.interaction._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        interactionFormErrors: InteractionValidate.validate({
          formObject: state.interaction,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_INTERACTION:
      return {
        ...state,
        interaction: { ...initialState.interaction },
        interactionFormErrors: InteractionValidate.validate({}),
        interactionFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        interactionFormTouched: true
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_INTERACTION:
      formSchemaType = (action.interaction || {})._id ? 'edit' : 'add'
      return {
        ...state,
        interaction: action.interaction,
        loadingInteraction: false,
        fetchInteractionError: false,
        interactionFormTouched: false,
        interactionFormErrors: InteractionValidate.validate({
          formObject: action.interaction,
          formSchemaType
        })
      }
    case FETCHING_INTERACTION:
      return {
        ...state,
        loadingInteraction: true,
        fetchInteractionError: false
      }
    case DELETE_INTERACTION:
      return {
        ...state,
        loadingInteractions: false,
        fetchInteractionError: false,
        interactions: state.interactions.map(interaction => {
          if (interaction._id === (action.interaction || {})._id) {
            return action.interaction
          }
          return interaction
        })
      }
    case FETCH_INTERACTION_ERROR:
      return {
        ...state,
        loadingInteractions: false,
        interaction: { ...initialState.interaction },
        fetchInteractionError: action.error
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case CHANGE_PAGE:
      return {
        ...state,
        interactionsPagination: {
          ...state.interactionsPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        interactionsPagination: {
          ...state.interactionsPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_INTERACTIONS:
      return {
        ...state,
        loadingInteractions: false,
        interactions: action.interactions,
        fetchInteractionsError: false,
        order: action.order,
        interactionsPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_INTERACTION:
      return {
        ...state,
        interactions: state.interactions.map(interaction => {
          if (interaction._id === action.interaction._id) {
            return action.interaction
          }
          return interaction
        }),
        loadingInteractions: false,
        fetchInteractionError: false,
        loadingInteraction: false,
        fetchInteractionsError: false
      }
    case FETCHING_INTERACTIONS:
      return {
        ...state,
        loadingInteractions: true,
        fetchInteractionsError: false
      }
    case FETCH_INTERACTIONS_ERROR:
      return {
        ...state,
        loadingInteractions: false,
        fetchInteractionsError: action.error,
        loadingInteraction: false
      }
    case ADD_INTERACTION:
      return {
        ...state,
        loadingInteractions: false,
        fetchInteractionsError: false,
        loadingInteraction: false,
        interactions: [...state.interactions, action.interaction]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default interactions



// WEBPACK FOOTER //
// ./src/reducers/interactions.js